import { useState, useEffect } from 'react';
import { Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Custom X (Twitter) icon component
const XIcon = ({ size = 18, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const iconMap = {
  facebook: Facebook,
  instagram: Instagram,
  linkedin: Linkedin,
  youtube: Youtube,
  twitter: XIcon
};

export default function SocialIcons() {
  const [socials, setSocials] = useState([]);

  useEffect(() => {
    const fetchSocialLinks = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/social-media-links`);
        setSocials(response.data);
      } catch (error) {
        console.error('Error fetching social media links:', error);
        // Fallback to default links
        setSocials([
          { id: '1', platform: 'facebook', url: 'https://facebook.com/thecircuit', enabled: true },
          { id: '2', platform: 'instagram', url: 'https://instagram.com/thecircuit.work', enabled: true },
          { id: '3', platform: 'linkedin', url: 'https://linkedin.com/company/thecircuit', enabled: true },
          { id: '4', platform: 'youtube', url: 'https://youtube.com/thecircuit', enabled: true }
        ]);
      }
    };
    fetchSocialLinks();
  }, []);

  if (socials.length === 0) return null;

  return (
    <div className="fixed right-8 top-24 z-40 hidden lg:flex flex-col space-y-4" data-testid="social-icons">
      {socials.map((social) => {
        const Icon = iconMap[social.platform.toLowerCase()] || Facebook;
        return (
          <a
            key={social.id}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={social.platform}
            data-testid={`social-${social.platform.toLowerCase()}`}
            className="w-10 h-10 flex items-center justify-center bg-white rounded-full shadow-md hover:bg-[#E12429] hover:text-white transition-all hover:scale-110"
          >
            <Icon size={18} />
          </a>
        );
      })}
    </div>
  );
}